module.exports = __webpack_public_path__ + "static/media/vtex9.b45ba9ad.png";